import type { PromoCode } from '@integrations/promo-codes/contracts/promo-code.contract';

import { inject } from '@angular/core';
import type { CreateQueryOptions } from '@tanstack/angular-query-experimental';
import { injectQuery } from '@tanstack/angular-query-experimental';
import { lastValueFrom } from 'rxjs';

import { PromoCodesApiService } from '../api/promo-codes-api.service';

export const PROMO_CODES_QUERY_KEY = ['promo-codes'] as const;

type PromoCodesQueryOverrides = Partial<Omit<CreateQueryOptions<PromoCode[]>, 'queryKey' | 'queryFn'>>;

export function injectPromoCodesQuery(optionsFn?: () => PromoCodesQueryOverrides) {
    const api = inject(PromoCodesApiService);

    return injectQuery(() => ({
        staleTime: 5 * 60 * 1000, // 5 minutes
        queryKey: PROMO_CODES_QUERY_KEY,
        queryFn: () => lastValueFrom(api.getPromoCodes()),
        ...optionsFn?.(),
    }));
}
